var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "page_Container" } }, [
    _c(
      "div",
      { staticClass: "page" },
      [
        _c("commonSearch", {
          attrs: {
            searchType: _vm.searchType,
            type: _vm.styleType,
            searchMassage: _vm.searchMassage
          },
          on: { goSearch: _vm.goSearch }
        }),
        _vm._v(" "),
        _c("div", { staticClass: "navbar" }, [
          _c("ul", { staticClass: "nav" }, [
            _c(
              "li",
              {
                class: { active: _vm.active == 0 },
                on: {
                  click: function($event) {
                    _vm.queryDataBysales()
                  }
                }
              },
              [
                _vm._v("销量"),
                _c("img", {
                  staticClass: "salesbtn",
                  attrs: { src: _vm.salesicon, alt: "" }
                })
              ]
            ),
            _vm._v(" "),
            _c(
              "li",
              {
                class: { active: _vm.active == 1 },
                on: {
                  click: function($event) {
                    _vm.queryDataByprice()
                  }
                }
              },
              [
                _vm._v("价格"),
                _c("img", {
                  staticClass: "pricebtn",
                  attrs: { src: _vm.priceicon, alt: "" }
                })
              ]
            ),
            _vm._v(" "),
            _c(
              "li",
              {
                staticClass: "nav-img",
                on: {
                  click: function($event) {
                    _vm.goevaluation()
                  }
                }
              },
              [
                _c("img", {
                  staticClass: "gobtn",
                  attrs: {
                    src: require("../assets/img/home/listimg.png"),
                    alt: ""
                  }
                }),
                _vm._v("分类")
              ]
            )
          ])
        ]),
        _vm._v(" "),
        _c("div", { attrs: { id: "main-container" } }, [
          _c(
            "div",
            { staticClass: "goods-container" },
            [
              _c(
                "van-pull-refresh",
                {
                  class: { flexClass: !_vm.listShow },
                  on: { refresh: _vm.onRefresh },
                  model: {
                    value: _vm.isLoading,
                    callback: function($$v) {
                      _vm.isLoading = $$v
                    },
                    expression: "isLoading"
                  }
                },
                [
                  _c(
                    "van-list",
                    {
                      attrs: { finished: _vm.finished, offset: 1 },
                      on: { load: _vm.onLoad },
                      model: {
                        value: _vm.ploading,
                        callback: function($$v) {
                          _vm.ploading = $$v
                        },
                        expression: "ploading"
                      }
                    },
                    [
                      _vm.listShow
                        ? _c(
                            "div",
                            _vm._l(_vm.goods, function(good) {
                              return _c(
                                "div",
                                {
                                  key: good.id,
                                  on: {
                                    click: function($event) {
                                      _vm.godetail(good)
                                    }
                                  }
                                },
                                [
                                  _c("goodCommon", {
                                    attrs: {
                                      good: good,
                                      disShow: _vm.retailStoreProductFlag
                                    }
                                  })
                                ],
                                1
                              )
                            }),
                            0
                          )
                        : _vm._e()
                    ]
                  ),
                  _vm._v(" "),
                  _vm.finishedOk && _vm.bottomShow
                    ? _c("listBottom")
                    : _vm._e(),
                  _vm._v(" "),
                  _c("div", { staticClass: "placeholder" })
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          !_vm.listShow
            ? _c("div", { staticClass: "nogood" }, [
                _c("img", { attrs: { src: _vm.noListUrl, alt: "" } }),
                _vm._v(" "),
                _c("p", [_vm._v("暂无商品")])
              ])
            : _vm._e()
        ])
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }